import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import { Toolbar, Typography, IconButton, MenuItem, Menu, Button, Grid, Avatar, Divider} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
//import ResponsiveMenu from "./responsiveMenu";
import ResponsiveMenu from "../../redux/containers/ResponsiveMenuContainer";
//import './header.css';
import Responsive from "react-responsive-decorator";
import {Link} from "react-router-dom";
import ProgressBar from "./ProgressBar";
import Can from "../../services/RolePermissionService";

const styles = theme => ({
    layout: {
        width: "auto",
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: "auto",
            marginRight: "auto",
        },
    },
    toolbarMain: {
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    toolbarTitle: {
        flex: 1,
    },
    toolbarSecondary: {
        justifyContent: "space-between",
    },
    mainFeaturedPost: {
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
        marginBottom: theme.spacing.unit * 4,
    },
    mainFeaturedPostContent: {
        padding: `${theme.spacing.unit * 6}px`,
        [theme.breakpoints.up("md")]: {
            paddingRight: 0,
        },
    },
    mainGrid: {
        marginTop: theme.spacing.unit * 3,
    },
    card: {
        display: "flex",
    },
    cardDetails: {
        flex: 1,
    },
    cardMedia: {
        width: 160,
    },
    markdown: {
        padding: `${theme.spacing.unit * 3}px 0`,
    },
    sidebarAboutBox: {
        padding: theme.spacing.unit * 2,
        backgroundColor: theme.palette.grey[200],
    },
    sidebarSection: {
        marginTop: theme.spacing.unit * 3,
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        marginTop: theme.spacing.unit * 8,
        padding: `${theme.spacing.unit * 6}px 0`,
    },
    button: {
        margin: theme.spacing.unit,
        textDecoration: "none"
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    logo: {
        width: "140px",
        height: "38px",
        backgroundImage: "url(\"/assets/img/DirectPay.png\")",
        backgroundPosition: "center", /* Center the image */
        backgroundRepeat: "no-repeat",/* Do not repeat the image */
        backgroundSize: "cover", /* Resize the background image to cover the entire container */
        margin: "16px 28px 16px 0",
        float: "left"
    },
    progressMenu: {
        zIndex: 5
    }
});

class MenuAppBar extends Component {

    state = {
        isMobile: false,
        auth: true,
        anchorEl: null,
        isAuthenticated: true,
    };

    componentDidMount() {
        this.props.media({minWidth: 768}, () => {
            this.setState({
                isMobile: false
            });
        });

        this.props.media({maxWidth: 768}, () => {
            this.setState({
                isMobile: true
            });
        });
    }

    handleChange = event => {
        this.setState({auth: event.target.checked});
    };

    handleMenu = event => {
        //console.log("current Target", event.currentTarget);
        this.setState({anchorEl: event.currentTarget});
    };

    handleClose = () => {
        this.setState({anchorEl: null});
    };

    logOut = () => {
        this.props.userLogOut();
        //this.props.resetMerchantDetails();
        this.setState({anchorEl: null});
    };

    goAdmin = () => {
        this.setState({anchorEl: null});
        this.props.history.push("/admin");
        //component={Link} to={'/admin'}
    };


    render() {
        // console.debug("Header",this.props)
        const {classes, location, history} = this.props;
        const {isAuthenticated, loading} = this.props.user;
        const { picture, fname } = this.props.userInfo;
        const {isMobile} = this.state;
        const {anchorEl} = this.state;
        const open = Boolean(anchorEl);

        const sections = [
            {name: "Technical Service", url: "/technicalService"},
            {name: "Transactions", url: "/transaction"},
            {name: "Products", url: "/products"},
            {name: "Redmo", url: "/redmo"},
            {name: "Account", url: "/account"},
        ];

        return (
            <div>
                {location.pathname.startsWith("/admin") ?
                    null
                    :
                    <div className={classes.root}>
                        <Toolbar className={classes.toolbarMain}>
                            <Typography variant="title" style={{color: "#012480", textDecoration: "none",}}
                                component={Link} to={"/"}>
                                Directpay
                            </Typography>
                            {/*<div alt="directpay" className={classes.logo} />*/}
                            <Grid container
                                direction="row"
                                justify="flex-end"
                                alignItems="flex-start">
                                {isMobile ?
                                    <ResponsiveMenu section={sections} isAuthenticated={isAuthenticated} history={history}/>
                                    :
                                    <div>
                                        {isAuthenticated ?
                                            <div>

                                                {sections.map(section => (
                                                    <Can do="view" on={section.url} key={section.name}>
                                                        <Button
                                                            key={section.name}
                                                            className={classes.button}
                                                            component={Link} to={section.url}
                                                        >
                                                            {section.name}
                                                        </Button>
                                                    </Can>
                                                ))}

                                                <IconButton aria-owns={open ? "menu-appbar" : null} aria-haspopup="true" onClick={this.handleMenu}>
                                                    {picture ?
                                                        <Avatar alt={fname} src={picture} />
                                                        :
                                                        <AccountCircle/>
                                                    }
                                                </IconButton>

                                                <Menu
                                                    id="menu-appbar"
                                                    anchorEl={anchorEl}
                                                    anchorOrigin={{
                                                        vertical: "top",
                                                        horizontal: "right",
                                                    }}
                                                    transformOrigin={{
                                                        vertical: "top",
                                                        horizontal: "right",
                                                    }}
                                                    open={open}
                                                    onClose={this.handleClose}
                                                >
                                                    <MenuItem component={Link} to={"/account/profile"}>
                                                        <Typography variant="caption" gutterBottom>
                                                            {this.props.userInfo.fname}
                                                        </Typography>
                                                        <Divider variant="middle"/>
                                                        <br/>
                                                        <Typography variant="overline" gutterBottom>
                                                            {this.props.userInfo.email}
                                                        </Typography>
                                                    </MenuItem>
                                                    <Divider variant="middle"/>
                                                    <Can do="view" on='/admin'><MenuItem onClick={this.goAdmin} dir="rtl">Admin</MenuItem></Can>
                                                    <MenuItem onClick={this.logOut} dir="rtl">Logout</MenuItem>
                                                </Menu>
                                            </div>
                                            :
                                            <div>

                                                <Button className={classes.button} variant="outlined" color="primary"
                                                    component={Link} to={"/"}>
                                                    Sign in
                                                </Button>
                                                {process.env.REACT_APP_ENV === "development" || process.env.REACT_APP_ENV === "local" ?
                                                    <Button className={classes.button} variant="outlined"
                                                        color="default" component={Link} to={"/signup"}>
                                                        Sign up
                                                    </Button>
                                                    :
                                                    null
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </Grid>
                        </Toolbar>
                        {loading ?
                            <ProgressBar className={classes.progressMenu}/>
                            :
                            null
                        }
                    </div>
                }
            </div>
        );
    }
}

MenuAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default Responsive(withStyles(styles)(MenuAppBar));
